import m from "mithril";
import assistant from "../../askbar/assistant";
import Sorter from "../../app/dnd/dnd";
import Btn from "../../app/components/button/index";
import {Icon, Icons, Dialog, Button} from "../../old/plugins/construct-ui";

export default ({attrs: {editable, customformat, text, onUpdate}}) => {
	// console.log("restarting", {editable, customformat, text, onUpdate});
	let options = (customformat.options || []).map((i) => {
		return {id: i.id || i, caption: i.caption || i.id || i};
	});
	let selectedlist = [];

	if (text) selectedlist = JSON.parse(text);

	selectedlist = selectedlist.map((i) => {
		return {id: i.id || i, caption: i.caption || i.id || i};
	});

	let finalSelectedList = selectedlist.map((a) => a.id);

	let dialogvisible = false;

	function ShowDialog() {
		if (editable) dialogvisible = true;
	}
	function DialogCancelled() {
		dialogvisible = false;
	}

	function RenderGroup(title, content) {
		return m(
			".group-wrapper",
			{
				style: {
					background: "#ddd",
					"border-radius": "0.25rem",
				},
			},
			[
				m(
					".title",
					{
						style: {
							padding: "0.5rem 1rem",
							"font-weight": "2",
							"font-size": "1.25rem",
						},
					},
					title
				),

				content,
			]
		);
	}
	function RenderItem(item, allowremove) {
		return m(
			".item",
			{
				uid: item.id,
				style: {
					padding: "0.5rem 1rem",
					border: "1px solid lightgray",
					"border-radius": "0.25rem",
					"margin-bottom": "0.5rem",
					cursor: "pointer",
					"user-select": "none",
					background: "white",
				},
			},
			item.caption
		);
	}
	function RenderList(items, res = {options: {}, groupoptions: {}}, onchange) {
		const {options, groupoptions} = {...res};
		return Sorter(
			m(
				".list-area",
				{
					style: {
						height: "40vh",
						"background-color": "#eee",
						overflow: "auto",
						padding: "0.5rem 0.5rem 2rem 0.5rem",
					},
					onchange: (order) => {
						if (onchange) onchange(order);
					},
				},
				items.map((i) => RenderItem(i))
			),
			"item-list",
			"uid",
			groupoptions,
			options
		);
	}
	function RenderOptionsList() {
		return RenderList(options, {groupoptions: {pull: "clone", put: false}, options: {sort: false}});
	}
	function RenderSelectedList() {
		return RenderList(
			selectedlist,
			{
				options: {
					removeOnSpill: true,
				},
			},
			(order) => {
				finalSelectedList = order;
			}
		);
	}

	return {
		view: () => {
			//there are 2 stages: 1 normal display of data 2: when editable allow clicking to show popup
			return m(
				".select-sequence-1.list-display",
				{
					style: {
						display: "flex",
						gap: "0.5rem",
						padding: "0.5rem",
						height: "100%",
						width: "100%",
						"flex-wrap": "wrap",
						"background-color": editable && "#ffebcd",
					},
					onclick: () => {
						if (!dialogvisible) ShowDialog();
					},
				},
				selectedlist.map((a) =>
					m(
						".tag",
						{
							style: {
								padding: "0.25rem 0.5rem",
								border: "1px solid lightblue",
								"user-select": "none",
								background: "white",
								"margin-bottom": "auto",
							},
						},
						a.caption
					)
				),
				m(Dialog, {
					class: "something-check",
					autofocus: true,
					basic: true,
					closeOnEscapeKey: true,
					closeOnOutsideClick: true,
					content: m(
						".selection-content",
						{
							style: {
								display: "grid",
								gap: "2rem",
								padding: "1rem",
								"grid-template-columns": "40ch 40ch",
							},
						},
						[
							RenderGroup(customformat.fromlist || "Choose Items", RenderOptionsList()),
							RenderGroup(customformat.tolist || "Selected Items", RenderSelectedList()),
						]
					),
					hasBackdrop: true,
					isOpen: dialogvisible,
					inline: false,
					onClose: DialogCancelled,
					// title: "Select",
					transitionDuration: 200,
					footer: m(`.cui-align-right`, [
						m(Button, {
							label: "Cancel",
							onclick: () => {
								DialogCancelled();
							},
						}),
						m(Button, {
							intent: "primary",
							label: "Save",
							onclick: () => {
								selectedlist = finalSelectedList.map((i) => {
									let option = options.find((o) => o.id == i.id);
									if (option) i.caption = option.caption;
									return i;
								});
								if (onUpdate) {
									onUpdate(JSON.stringify(selectedlist));
								}
								dialogvisible = false;
							},
						}),
					]),
				})
			);
		},
	};
};
